import React, { ReactNode } from "react";
import cn from "classnames";
import s from "./Preamble.module.scss";
import bs from "../../styles/block.spacing.module.scss";
import type { RichTextContent } from "../../lib/storyblok/types/fieldtypes/richText";
import BlockIntro from "../Common/BlockIntro";
import {
  AlignmentVariant,
  HeadingVariant,
} from "../../lib/storyblok/types/shared";

type Props = {
  title?: string;
  labelAs?: HeadingVariant;
  text?: RichTextContent;
  featured?: boolean;
  noTopPadding?: boolean;
  noBottomPadding?: boolean;
  innerSpacing?: string;
  contentAlignment?: AlignmentVariant;
  buttons?: ReactNode;
};

const Preamble = ({
  title,
  labelAs = "h2",
  text,
  featured = true,
  noTopPadding,
  noBottomPadding,
  innerSpacing = "both",
  contentAlignment = "alignCenter",
  buttons,
}: Props) => {
  const innerSpacingCleanup = noTopPadding
    ? "onlyBottom"
    : noBottomPadding
    ? "onlyTop"
    : innerSpacing;

  return (
    <div className={cn(s.preamble, bs[innerSpacingCleanup])}>
      <BlockIntro
        title={title}
        description={text}
        headingTag={labelAs}
        width={"contained"}
        alignment={contentAlignment}
        buttons={buttons}
        inverted={false}
        titleSize={featured ? "large" : "preamble"}
        titleWeight={featured ? "bold" : "default"}
        descriptionSize={featured ? "large" : "default"}
        descriptionWeight={featured ? "bold" : "default"}
      />
    </div>
  );
};

export default Preamble;
